<template>
  <div class="mul-choice">
    <div class="content-stem">
      <span class="ques-num">{{ currentQuestion.showSerialNum }}</span>
      <span v-html="currentQuestion.content"/>
    </div>
    <div class="content-list">
      <div class="content-option" v-for="(option, index) in currentQuestion.optionList" :key="index">
        <label>
          <input type="checkbox" name="multipleQuestion" :value="option.quesValue" v-model="userAnswer"
                 @change="checkboxFn">
          <strong>{{ option.quesValue }}.&nbsp;</strong>
          <span v-html="option.quesOption"/>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'ExamMultipleChoice',
    data() {
      return{

      }
    },
    computed: {
      ...mapGetters([
        'currentQuestion',
        'currentQuestionIndex'
      ]),
      userAnswer: {
        get() {
          return this.currentQuestion.userAnswer
        },
        set(value) {
          this.$store.dispatch('setUserAns', value)
        }
      }
    },
    mounted() {

    },
    methods: {
      checkboxFn() {
        let value = this.currentQuestion.userAnswer
        let isAnswer = value.length ? 1 : 0
        this.$store.dispatch('setIsAns', isAnswer)
      }
    }
  }
</script>
